// @flow

import React from "react";
import Helmet from "react-helmet";
import PrismicDOM from "prismic-dom";
import WorkGrid from "../components/WorkGrid";
import ArticleSlices from "../components/ArticleSlices";
import styled from "react-emotion";
import { theme, mqMin } from "../styles/theme";
import { toHtml } from "../utilities";

const Cover = styled.div`
  position: relative;
  z-index: 2;
  max-width: ${theme.breakpoints[3]};
  margin-top: ${theme.space4};
  margin-bottom: ${theme.space5};
  padding-left: ${theme.space1};
  padding-right: ${theme.space1};
  margin-left: auto;
  margin-right: auto;
`;

const Heading = styled.div`
  font-family: ${theme.heading.fontFamily};
  font-weight: ${theme.heading.bold};
  font-size: ${theme.h1};
  line-height: ${theme.lineHeight2};
  text-align: center;
  ${mqMin(theme.tablet)} {
    font-size: ${theme.super};
  }
`;

const Subtext = styled.div`
  font-family: ${theme.sans.fontFamily};
  font-weight: ${theme.sans.normal};
  font-size: ${theme.h4};
  margin-top: ${theme.space1};
  text-align: center;
  ${mqMin(theme.tablet)} {
    font-size: ${theme.h3};
  }
`;

export default ({ data, ...props }) => {
  console.log(data);
  const slug = props.pathContext.slug;
  const articles = data.work.edges.filter(n => n.node.uid === slug);
  if (articles.length < 1) {
    return null;
  }

  const article = articles[0].node.data;
  const title = article.title || article.client_name;
  const tags = [
    { itemprop: "name", content: "PandaGoat Media" },
    { name: "twitter:card", content: "summary" },
    { name: "twitter:title", content: `PaNDAGOAT MEDIA - ${title}` },
    { name: "og:title", content: `PaNDAGOAT MEDIA - ${title}` },
    { name: "og:url", content: props.pathContext.path },
    { name: "og:site_name", content: "Panda Goat Media" },
    { name: "og:type", content: "website" },
    { name: "twitter:site", content: "@pandagoatmedia ‏" },
    { name: "twitter:creator", content: "@pandagoatmedia ‏" },
    {
      name: "description",
      value: article.description
        ? article.description.text
        : article.lead_in.text
    }
  ];

  return (
    <Cover>
      <Helmet title={article.title || article.client_name} meta={tags} />
      <Heading>{article.client_name || article.title}</Heading>
      <Subtext dangerouslySetInnerHTML={{ __html: article.lead_in.html }} />
      <ArticleSlices slices={article.body} />
    </Cover>
  );
};

export const pageQuery = graphql`
  query ArticlePages {
    work: allPrismicArticle {
      edges {
        ...Article
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/article.js